
export const calculateScalingFactor = (
    containerWidth : number,
    containerHeight : number,
    imageWidth : number,
    imageHeight : number
) => {

    const containerRatio = containerWidth / containerHeight
    const imageRatio = imageWidth / imageHeight

    if (imageRatio < containerRatio) { //width is smaller
      return imageWidth * containerHeight / imageHeight 
    } else {   
      return 1 / (containerHeight / imageHeight)
    }
}

export const ImageDimensions = ({ src, setImageRatio } : {
    src : string,
    setImageRatio : (ratio : number) => void
}) => {

    const handleImageLoad = (event : any) => {
        const { naturalWidth: width, naturalHeight: height } = event.target;
        setImageRatio( width / height );
      };
    
      return (
        <div>
          <img
            src={src}
            alt="Image"
            onLoad={handleImageLoad}
            style={{ display: 'none' }} // hide the image element
          />
        </div>
      );

}